<template>
<b-container id="tjanster" class="services">
    <h2 class="md-section-title">Våra tjänster</h2>

    <b-row id="ritningar" class="service md-surface" no-gutters>
        <b-col cols="12" md="6" order="2" order-md="1">
            <div class="service-description">
                <div class="service-heading">
                    <span class="md-icon"><inline-svg :src="svg('pen-tool.svg')" width="24" height="24" /></span>
                    <span>Ritningar</span>
                </div>

                <p>
                    Är du i behov av byggritningar? Vi levererar alltid hög kvalité!
                </p>
                <b-button variant="primary" to="/kontakt">Kontakta oss</b-button>
            </div>
        </b-col>
        <b-col cols="12" md="6" order="1" order-md="2">
            <div class="service-image">
                <b-img :src="image('plans.jpg')" alt="" loading="lazy" />
            </div>
        </b-col>
    </b-row>

    <b-row id="kontrollansvar" class="service md-surface" no-gutters>
        <b-col cols="12" md="6">
            <div class="service-image">
                <b-img :src="image('clipboard.jpg')" alt="" loading="lazy" />
            </div>
        </b-col>
        <b-col cols="12" md="6">
            <div class="service-description">
                <div class="service-heading">
                    <span class="md-icon"><inline-svg :src="svg('clipboard.svg')" width="24" height="24" /></span>
                    <span>Kontrollansvar, KA</span>
                </div>

                <p>
                    Ska du bygga och behöver du en certifierad kontrollansvarig? Då har du hittat rätt! Vi hjälper dig och ser till
                    att bygget uppfyller alla krav enligt bygglagstiftningen.
                </p>
                <p>
                    Vi finns med dig hela vägen under bygget! Vi tar fram ett förslag på kontrollplan, vi ser till att kontrollplanen håller,
                    deltar i tekniska samrådet samt besiktningen och övriga kontroller.
                </p>
                <b-button variant="primary" to="/kontakt">Vill du veta mer? Kontakta oss</b-button>
            </div>
        </b-col>
    </b-row>

    <b-row id="redovisning" class="service md-surface" no-gutters>
        <b-col cols="12" md="6" order="2" order-md="1">
            <div class="service-description">
                <div class="service-heading">
                    <span class="md-icon"><inline-svg :src="svg('trending-up.svg')" width="24" height="24" /></span>
                    <span>Redovisningstjänster</span>
                </div>

                <p>
                    Vi erbjuder olika redovisningstjänster till dig som företagare. Behöver du hjälp med bokslutet,
                    eller kanske bara vill ha en genomgång av ditt bolags redovisning för att kontrollera att allt ser bra ut?
                </p>
                <p>
                    Har du svårt med att förstå momsrapporten eller behöver hjälp med att med nyckeltal få bästa vägen framåt för just ditt bolag?
                </p>

                <div class="font-weight-bold text-body">Ex på priser (ex moms)</div>
                <div class="price-list">
                    <div class="price-row">
                        <span>Bokslut aktiebolag</span>
                        <span class="price">5 900 SEK*</span>
                    </div>
                    <div class="price-row">
                        <span>Bokslut enskild firma</span>
                        <span class="price">3 900 SEK*</span>
                    </div>
                </div>
                <p class="price-note">*Priserna bygger på att bokföringen är korrekt. Vid ev justeringar tillkommer ett timpris om 699 SEK/h ex moms</p>
            </div>
        </b-col>
        <b-col cols="12" md="6" order="1" order-md="2">
            <div class="service-image">
                <b-img :src="image('economy.jpg')" alt="" loading="lazy" />
            </div>
        </b-col>
    </b-row>
</b-container>
</template>

<script>
export default {
    name: 'Services',
    methods: {
        image(path) {
            return this.$images.pageImage(path);
        },
        svg(path) {
            return this.$images.svg(path);
        }
    }
};
</script>
